import { createAction } from '@reduxjs/toolkit';
import { retailersGroupsTitlesSlice } from './reducer';

export const fetchRetailersGroupsTitles = createAction('retailersGroupsTitles/fetchRetailersGroupsTitles');

export const { receiveRetailersGroupsTitles, receiveMarketingCopy } = retailersGroupsTitlesSlice.actions;
